import { createFileRoute, redirect } from "@tanstack/react-router"
import { userQueryOptions } from "@/entities/user"
import { SignupWelcomePage } from "@/pages/onboarding"

export const Route = createFileRoute("/onboarding/signup-welcome")({
	beforeLoad: async ({ context }) => {
		if (context.userId === null) throw redirect({ to: "/" })
		const user = await context.queryClient.query({
			...userQueryOptions(context.userId),
			staleTime: "static",
		})
		return { firstName: user.luni_name }
	},
	component: SignupWelcomePage,
})
